
export const combinationOCXOcsac = {
  frequencyInput: {
    type: "select", //or select
    array: [8.192,300] //if inputs min..max 2 items, select -> [8,10,20] for xbo25
  },
  temperatureRanges: [
    { code: "6", range: "-10..60ºC" },
    { code: "7", range: "-30..70ºC" },
    { code: "8", range: "-40..80ºC" },
  ],
  frequencyOptions:[
    { code: "8.192", value: "8.192", label: "8.192 MHz" },
    { code: "10", value: "10", label: "10 MHz" },
    { code: "16.384", value: "16.384", label: "16.384 MHz" },
    { code: "20", value: "20", label: "20 MHz" },
  ],
  supplyTypes: [
    { voltage: "3.3V", value: "3.3V" },
    { voltage: "5V", value: "5V" }
  ],
  agingOptions: [
    { code: "50", ppbPerMonth: "0.5" },
    { code: "19", ppbPerMonth: "1" },
    { code: "29", ppbPerMonth: "2" },
    { code: "20", ppbPerMonth: "0.2" },
  ],
  stabilityOptions: [
    { code: "50", value: "0.5", unit: "ppb" },
    { code: "19", value: "1", unit: "ppb" },
    { code: "29", value: "2", unit: "ppb" },
    { code: "39", value: "3", unit: "ppb" },
    { code: "59", value: "5", unit: "ppb" },
    { code: "18", value: "10", unit: "ppb" },
    { code: "28", value: "20", unit: "ppb" },
    { code: "38", value: "30", unit: "ppb" },
    { code: "58", value: "50", unit: "ppb" }
  ]
  
}
